export default __webpack_public_path__ + "static/media/create-supporting1.4365cd7e.jpg";